// extracted by mini-css-extract-plugin
module.exports = {"deletePlaceholderContainer":"delete-placeholder_deletePlaceholderContainer__2iUsk","icon":"delete-placeholder_icon__2TdjQ"};